import { render } from "./ChartDoughnut.vue?vue&type=template&id=412cc407"
import script from "./ChartDoughnut.vue?vue&type=script&lang=js"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartDoughnut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "412cc407"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('412cc407', __exports__)) {
    api.reload('412cc407', __exports__)
  }
  
  module.hot.accept("./ChartDoughnut.vue?vue&type=template&id=412cc407", () => {
    api.rerender('412cc407', render)
  })

}


export default __exports__